/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useEffect, useContext } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF as JsPDF } from "jspdf";
import { CopyToClipboard } from 'react-copy-to-clipboard';
// import Select from 'react-select';
// import { ScreenCapture } from 'react-screen-capture';
import { BrowserMultiFormatReader, BrowserQRCodeReader } from '@zxing/library';
import Toast from '../Toast/index';
import './qrScanner.css';
import {
  GALLERY_ICON,
  // FLASH_ICON,
  // GREEN_TICK_MARK,
  SHARE_BUTTON_ICON,
  DOWNLOAD_BUTTON_ICON,
  COPY_ICON,
  QR_ERROR,
} from '../../constants/urls';
import logo from './approvalgreentick.png';
import { UserContext } from '../context/userContext';
import { useGlobalState } from '../context/qrState';
import {
  ShareButton,
  DownloadButton,
  ContainerDiv,
  ScannerToolbar,
  DetailsContainerDiv,
  FooterText,
  DetailDiv,
  DetailsToolbar,
  Item,
  CopyImage,
  QRErrorDiv,
  ScanAgain,
  QRImg,
  QRErrorText,
  QRErrorBox,
  BtnIcons,
  ItemLabel,
} from './styles';
import { DrawerOverlay } from '../bottomDraw/styles';
import { QRFieldsMap, QRScanResult } from './types';
import { track } from '../../analytics/analytics';
import { EventIDs } from '../../analytics/events';
import { ErrorToastText, ToastNature } from '../../common/types';

const jwt = require('jsonwebtoken');

// latest govt keys got from here: https://einvoice1.gst.gov.in/Others/Publickeys

const govtKeyForProduction =
  '-----BEGIN PUBLIC KEY-----\n' +
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAus9fu9tuMwxbdRdln+Ej\n' +
  'dfk7zrXMT54q2Ow8oiKxjvHjv7PdjLQ6c1w4HOQhgYg+3pkF7E/Q1PGgfLgaNSKF\n' +
  'weh2qFtNcrl1F/SbPfEnuvYl9cBxaevm4GGCS61iH/VG3UcK0ni2hr7Js5NV5tKM\n' +
  'AD4x9aqBW/gFvyzBfLItr1K+G2poIuOlAjb4PpDKpxWmjrLJdutL8hp9VyMnXtJN\n' +
  'iriYDbF8aK6FIsEGU3D9T0iIp8+0bgbA+n2SYzL/MhixcE9tSFovkSZrtnhkHFSm\n' +
  'WhQSMk81bjMZ2FpRmn/YSGB6flBRa5/1Eu8NDOARou5OM1sHiZ0CMxRCy+hUAPtT\n' +
  'FQIDAQAB\n' +
  '-----END PUBLIC KEY-----';

const govtKey = process.env.REACT_APP_ACTIVE_ENV === 'production' ?  govtKeyForProduction : govtKeyForProduction;

console.log('ACTIVE_ENV--',process.env.REACT_APP_ACTIVE_ENV)

const QRScanner = () => {
  const [code, setCode] = useState<null | string>(null);
  const [details, setDetails] = useState<null | { data: any }>(null);
  const [sigValid, setSigValid] = useState<null | boolean>(false);
  // const [screenCapture, setScreenCapture] = useState('');
  const [clickedDownload, setClickedDownload] = useState(false);
  const [qrImage, setQrImage] = useState<null | { preview: any; raw: any }>(
    null
  );
  const [cameraAccess, setCameraAccess] = useState(true);
  const [imgElementNode, setImgNode] = useState<HTMLImageElement | null>(null);
  const codeReader = new BrowserMultiFormatReader();
  const qrImageScanner = new BrowserQRCodeReader();
  // const { image, takeScreenshot } = useScreenshot();
  const [currentlyShowingQrDetails, updateQrDetailState] = useGlobalState(
    'onQrDetailPage'
  );
  const [outOfScanner, updateExitScanner] = useGlobalState('exitScanner');
  const { businessDetails, email } = useContext<Record<string, any>>(
    UserContext
  );
  const videoPlayer = document.querySelector('#video');
  const qRDetails = [
    'Supplier GSTIN',
    'Recipient GSTIN',
    'Document No.',
    'Document Type',
    'Document Date',
    'Total Invoice Value',
    'No. of Line Items',
    'Main HSN Code',
    'IRN',
    'IRN Date',
  ];

  useEffect(() => {
    businessDetails.addPageName('QR');
  }, []);

  useEffect(() => {
    // @ts-ignore:next-line
    navigator.permissions.query({ name: 'camera' }).then((res) => {
      if (res.state === 'granted') {
        setCameraAccess(true);
        // console.log('has permission');
      } else {
        setCameraAccess(false);
        updateQrDetailState(false);
        // console.log('no permission');
        // console.log(code);
      }
    });
  }, [code]);

  const decodeOnce = () => {
    codeReader
      .decodeFromInputVideoDevice(undefined, 'video')
      .then((result: any) => {
        setCode(result.text);
        // console.log('Found the QR code: ', result);
      })
      .catch((err) => {
        // console.log(err);
        setCode(err);
      });
  };

  useEffect(() => {
    if (!code) {
      if (cameraAccess) {
        decodeOnce();
      }
    } else if (code !== 'invalid') {
      closeCamera();
      // console.log('#### decode and verify JWT token now: ', code);
      verifyToken(code);
    } else {
      updateQrDetailState(true);
    }
  }, [code]);

  const verifyToken = (token: any) => {
    try {
      jwt.verify(
        token,
        govtKey,
        { algorithm: ['RS256'] },
        (err: any, decoded: any) => {
          updateQrDetailState(true);
          if (!err) {
            setDetails(decoded);
            // console.log('Valid Signature: ', decoded);
            setSigValid(true);
          } else {
            const decodedData = jwt.decode(token, { complete: true });
            console.log(decodedData);
            setCode('invalid');
            console.log('Invalid Signature',err);
            setSigValid(false);
          }
        }
      );
    } catch (e) {
      // console.log(e);
      // console.log('Invalid Signature');
    }
  };
  function resetClick() {
    codeReader.reset();
    businessDetails.addPageName('QR');
    setCode(null);
    setSigValid(null);
    setQrImage(null);
    setImgNode(null);
    updateQrDetailState(false);
  }
  const scanAgainClick = () => {
    const payload = {
      email,
    };
    track(EventIDs.SCAN_AGAIN_CLICK, payload);
    resetClick();
  };

  function closeCamera() {
    if (videoPlayer) {
      // @ts-ignore
      if (videoPlayer.srcObject) {
        // @ts-ignore
        videoPlayer.srcObject.getVideoTracks().forEach((trackQr: any) => {
          trackQr.stop();
        });
      }
    }
  }

  useEffect(() => {
    if (outOfScanner) {
      closeCamera();
      updateExitScanner(false);
    }
  }, [outOfScanner]);

  useEffect(() => {
    if (clickedDownload) {
      downloadScreenShot();
    }
  }, [clickedDownload]);

  useEffect(() => {
    const payload = {
      email,
    };
    if (sigValid === true) {
      track(EventIDs.SCAN_VALID, payload);
    }
  }, [sigValid]);

  const scanQrCodeFromImage = (imgElement: any) => {
    if (imgElement) {
      qrImageScanner
        .decodeFromImage(imgElement)
        .then((result: any) => {
          // console.log('Scanning result from image: ', result);
          setCode(result.text);
        })
        .catch((err) => {
          // console.log('Scanning error from image: ', err);
          setCode('invalid');
          // console.log('Invalid Signature');
          const payload = {
            email,
          };
          track(EventIDs.SCAN_AGAIN, payload);
          setSigValid(false);
        });
    }
  };

  const imgUploadElementRef = React.useCallback((qrImgNode) => {
    // console.log('qr image node is: ', qrImgNode);
    setImgNode(qrImgNode);
    scanQrCodeFromImage(qrImgNode);
  }, []);

  const handleImageUploadChange = (e: any) => {
    // console.log('about to try scanning a new image: ', e.target.files[0]);
    setQrImage(null);
    setImgNode(null);
    if (e.target.files.length) {
      setQrImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
      // console.log('Image element ref: ', imgUploadElementRef);
    }
  };

  const changeIRNForDnld = () => {
    setClickedDownload(true);
  };
  const replaceSlashWithUnderscoreInDocNo = (invoiceNumber: string)=> invoiceNumber?.replaceAll('/','_');

  const downloadScreenShot = async () => {
    const payload = {
      email,
    };
    track(EventIDs.QR_DOWNLOAD, payload);

    const qrResultData = JSON.parse(details!.data) as QRScanResult;
    const formattedDocNumber = replaceSlashWithUnderscoreInDocNo(qrResultData?.DocNo)
    // @ts-ignore
    html2canvas(document.querySelector('#qrDetails')).then((canvas: any) => {
      const imageURL = canvas.toDataURL('image/png');
      // Files are downloading in PNG format instead of PDF, implement this functionality
      const pdf = new JsPDF("p", "mm", "a4");
      const width = pdf.internal.pageSize.getWidth();    
      const height = pdf.internal.pageSize.getHeight();
      pdf.addImage(imageURL, 'JPEG', 0, 0,width,height);
      pdf.save(`${qrResultData?.DocTyp}_${qrResultData?.BuyerGstin}_${qrResultData?.SellerGstin}_${formattedDocNumber}.pdf`); 

      // const link = document.createElement('a');
      // link.href = imageURL;
      // link.download = `${qrResultData.DocTyp}_${qrResultData.MainHsnCode}`;
      // link.click();
      // console.log('downloaded successfully');
      setClickedDownload(false);
    });
  };

  const shareScreenShot = () => {
    const payload = {
      email,
    };
    track(EventIDs.QR_SHARE, payload);

    const qrResultData = JSON.parse(details!.data) as QRScanResult;
    let text = '';
    for (const [key, value] of Object.entries(qrResultData)) {
      text = text.concat(`${QRFieldsMap.get(key)}: ${value}\n\n`);
    }

    try {
      navigator
        .share({
          title: 'Invoice',
          text,
        })
        .then(() => {
          // console.log('Share was successful.')
          Toast.notify({
            description: 'Invoice successfully shared!',
            nature: ToastNature.SUCCESS,
          });
        })
        .catch((error) => {
          // console.log('Sharing failed', error);
          if (error.message.startsWith('Internal error:')){
            Toast.notify({
              description: ErrorToastText.SHARE_INV_DETAILS,
              nature: ToastNature.ERROR,
            });
          }
        });
    } catch (e) {
      // console.log(`Your system doesn't support sharing files.`);
    }
  };

  useEffect(() => {
    // console.log('#### qrCode Details has changed: ', currentlyShowingQrDetails);
    if (!currentlyShowingQrDetails) {
      // console.log('RESETTING QR SCREEN - STARTING SCANNER AGAIN');
      const payload = {
        email,
      };
      track(EventIDs.QR_PAGE, payload);
      resetClick();
    } else {
      // console.log('MOVING TO DETAILS PAGE NOW');
    }
  }, [currentlyShowingQrDetails]);

  const onCopyclick = () => {
    const description = 'IRN code has been copied to your clipboard!';
    Toast.notify({ description, nature: ToastNature.SUCCESS });
  };

  return (
    <>
      {!code && cameraAccess && (
        <ContainerDiv>
          <div>
            {!qrImage && (
              <div>
                <video
                  className="scanningPort"
                  id="video"
                  width="300"
                  height="300"
                />
                <span className="scanningHelpText">
                  Please align the QR code
                  <br /> within the scanner
                </span>
              </div>
            )}
            {qrImage && qrImage.preview && qrImage.raw && (
              <div>
                <img
                  ref={imgUploadElementRef}
                  style={{ maxHeight: '300px' }}
                  src={qrImage.preview}
                  alt="uploaded qr img"
                />
              </div>
            )}
          </div>
          <ScannerToolbar>
            <label
              style={{ paddingTop: '10px', paddingLeft: '15px' }}
              htmlFor="upload-button"
            >
              <img
                src={GALLERY_ICON}
                alt=""
                onClick={() => {
                  const payload = {
                    email,
                  };
                  track(EventIDs.GALLERY_ICON_CLICK, payload);
                }}
              />
            </label>
            <input
              type="file"
              id="upload-button"
              style={{ display: 'none' }}
              onChange={handleImageUploadChange}
            />
            {/* <img src={FLASH_ICON} /> */}
          </ScannerToolbar>
        </ContainerDiv>
      )}
      {!cameraAccess && (
        <ContainerDiv>
          <QRErrorDiv>
            <QRErrorBox>
              <QRImg src={QR_ERROR} alt="" height="22px" width="22px" />
              <QRErrorText>
                Camera is blocked. <br /> Please check the site settings to
                allow camera access
              </QRErrorText>
            </QRErrorBox>
          </QRErrorDiv>
        </ContainerDiv>
      )}
      {code && sigValid && (
        <DetailsContainerDiv>
          <div id="qrDetails">
            <DetailDiv>
              {Object.entries(JSON.parse(details!.data)).map(
                (eachItem: any, index) => (
                  <Item key={eachItem[0]}>
                    <ItemLabel>{qRDetails[index]}</ItemLabel>
                    {eachItem[0] === 'Irn' && (
                      <>
                        {' '}
                        {clickedDownload ? (
                          <span
                            style={{
                              height: '70px',
                              width: '52%',
                              wordBreak: 'break-all',
                            }}
                          >
                            {eachItem[1]}
                          </span>
                        ) : (
                          <span style={{ textOverflow: 'ellipsis' }}>
                            {eachItem[1].toString().substring(0, 6)}...
                          </span>
                        )}
                        {!clickedDownload && (
                          <CopyToClipboard text={eachItem[1]}>
                            <CopyImage
                              src={COPY_ICON}
                              alt=""
                              height="14px"
                              width="14px"
                              onClick={onCopyclick}
                            />
                          </CopyToClipboard>
                        )}
                      </>
                    )}
                    {eachItem[0] === 'TotInvVal' && (
                      <span>Rs. {eachItem[1]}</span>
                    )}
                    {eachItem[0] !== 'TotInvVal' &&
                      eachItem[0] !== 'Irn' &&
                      eachItem[1]}
                  </Item>
                )
              )}
            </DetailDiv>
            {sigValid && (
              <FooterText>
                <img src={logo} alt="" />
                <span style={{ left: '8px' }}>
                  This is digitally signed by Clear-IRP
                </span>
              </FooterText>
            )}
          </div>
          <DetailsToolbar>
            <DownloadButton onClick={changeIRNForDnld}>
              <BtnIcons
                src={DOWNLOAD_BUTTON_ICON}
                alt=""
                height="48px"
                width="48px"
                margin={7}
              />
              <span style={{ marginLeft: '-6px' }}> Download</span>
            </DownloadButton>
            <ShareButton onClick={shareScreenShot}>
              <BtnIcons
                src={SHARE_BUTTON_ICON}
                alt=""
                height="48px"
                width="48px"
                margin={10}
              />
              <span style={{ marginLeft: '-5px' }}>Share</span>
            </ShareButton>
          </DetailsToolbar>
        </DetailsContainerDiv>
      )}
      {code === 'invalid' && !sigValid && cameraAccess && (
        <ContainerDiv>
          <QRErrorDiv>
            <QRErrorBox>
              <QRImg src={QR_ERROR} alt="" height="22px" width="22px" />
              <QRErrorText>
                No valid QR Code detected.
                <br />
                Please try again.
              </QRErrorText>
            </QRErrorBox>
            <ScanAgain onClick={scanAgainClick}>Scan Again</ScanAgain>
          </QRErrorDiv>
          <ScannerToolbar>
            <label
              style={{ paddingTop: '10px', paddingLeft: '15px' }}
              htmlFor="upload-button"
            >
              <img src={GALLERY_ICON} alt="" />
            </label>
            <input
              type="file"
              id="upload-button"
              style={{ display: 'none' }}
              onChange={handleImageUploadChange}
            />
            {/* <img src={FLASH_ICON} /> */}
          </ScannerToolbar>
          <DrawerOverlay zIndex={200} />
        </ContainerDiv>
      )}
    </>
  );
};
export default QRScanner;
